import { AppBar, Toolbar, Container, Box, Typography, useTheme, IconButton } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import ProfileMenuComponent from "./ProfileMenuComponent";
import LoggedInProfileMenuComponent from "./LoggedInProfileMenuComponent";
import { useAuth } from "../../auth/AuthContext";

interface HeaderComponentProps {
  onMobileMenuToggle?: () => void;
  isMobile?: boolean;
}

const HeaderComponent = ({ onMobileMenuToggle, isMobile = false }: HeaderComponentProps) => {
  const theme = useTheme();
  const { isAuthenticated } = useAuth();

  return (
    <AppBar 
      position="fixed" 
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        zIndex: theme.zIndex.drawer + 1, // Ensure header is above sidebar
        height: { xs: '56px', sm: '72px' },
      }}
    >
      <Container maxWidth="xl">
        <Toolbar 
          sx={{ 
            minHeight: { xs: '56px', sm: '72px' },
            px: { xs: 1, sm: 2 },
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Mobile Menu Button - Only show on mobile when authenticated */}
            {isMobile && isAuthenticated && (
              <IconButton
                onClick={onMobileMenuToggle}
                sx={{
                  color: theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light + '20',
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
            
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: { xs: 1, sm: 2 },
                cursor: 'pointer',
                '&:hover': {
                  transform: 'scale(1.02)',
                },
                transition: 'transform 0.2s ease-in-out',
              }}
            >
              <Box 
                component="img" 
                src="/favicon.svg" 
                alt="PocketBalance" 
                sx={{ height: { xs: 28, sm: 36 }, width: { xs: 28, sm: 36 } }} 
              />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  letterSpacing: '-0.5px',
                  fontSize: { xs: '1rem', sm: '1.5rem' },
                }}
              >
                PocketBalance
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isAuthenticated ? <LoggedInProfileMenuComponent /> : <ProfileMenuComponent />}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default HeaderComponent;
